import { Icon } from '@chakra-ui/react';

export const IconJustMinus = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <path fill="currentColor" d="M13 6a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2h12Z" />
  </Icon>
);
